import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteWebpage } from 'action/webpage'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (title) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${title}`,
      success: 'Webpage deleted'
    }
  }
})

const DeleteWebpage = ({ deleteWebpage, webpage: { uuid, title }, pagination }) => {
  const handleSubmit = () => deleteWebpage(uuid)

  const { decide, outcome } = generateModalText(title)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete Webpage</a>
  )
}

DeleteWebpage.propTypes = {
  deleteWebpage: PropTypes.func,
  pagination: PropTypes.object,
  webpage: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteWebpage: bindActionCreators(deleteWebpage, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.webpage.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteWebpage)
